import { Injectable } from '@angular/core';
import { IGroupConfig, Permission, PermissionChecker } from '@socrates/common';
import { IPermissionsRepo } from '../interfaces/ipermissions.repo';

class TestGroupsConfig extends IGroupConfig {
	private _groups = {
		"permissions": [
			{
				"permission": "ADMIN",
				"accessLevels": [
					{ "groupName": "[ENV]_SUPER_ADM", "label": "ADMIN", "accessLevel": 10000000 }
				]
			},
			{
				"permission": "OrganizationProvision",
				"accessLevels": [
					{ "groupName": "[ENV]_ORG_RD",  "label": "READ",   "accessLevel": 1 },
					{ "groupName": "[ENV]_ORG_UPD", "label": "UPDATE", "accessLevel": 2 },
					{ "groupName": "[ENV]_ORG_ADM", "label": "ADMIN",  "accessLevel": 3 }
				]
			},
			{
				"permission": "UserManagement",
				"accessLevels": [
					{ "groupName": "[ENV]_USR_MGT_RD",  "label": "READ",   "accessLevel": 1 },
					{ "groupName": "[ENV]_USR_MGT_UPD", "label": "UPDATE", "accessLevel": 2 },
					{ "groupName": "[ENV]_USR_MGT_ADM", "label": "ADMIN",  "accessLevel": 3 }
				]
			},
			{
				"permission": "IdeaManagement",
				"accessLevels": [
					{ "groupName": "[ENV]_IDEA_RD",  "label": "READ",   "accessLevel": 1 },
					{ "groupName": "[ENV]_IDEA_UPD", "label": "UPDATE", "accessLevel": 2 },
					{ "groupName": "[ENV]_IDEA_ADM", "label": "ADMIN",  "accessLevel": 3 }
				]
			},
			{
				"permission": "PillarManagement",
				"accessLevels": [
					{ "groupName": "[ENV]_PILLAR_RD",  "label": "READ",  "accessLevel": 1 },
					{ "groupName": "[ENV]_PILLAR_ADM", "label": "ADMIN", "accessLevel": 3 }
				]
			},
			{
				"permission": "FloorManagement",
				"accessLevels": [
					{ "groupName": "[ENV]_FLOOR_RD",  "label": "READ",  "accessLevel": 1 },
					{ "groupName": "[ENV]_FLOOR_ADM", "label": "ADMIN", "accessLevel": 3 }
				]
			},
			{
				"permission": "ModerationManagement",
				"accessLevels": [
					{ "groupName": "[ENV]_MOD_RD",  "label": "READ",  "accessLevel": 1 },
					{ "groupName": "[ENV]_MOD_ADM", "label": "ADMIN", "accessLevel": 3 }
				]
			},
			{
				"permission": "ConfigManagement",
				"accessLevels": [
					{ "groupName": "[ENV]_CONFIG_RD",  "label": "READ",   "accessLevel": 1 },
					{ "groupName": "[ENV]_CONFIG_UPD", "label": "UPDATE", "accessLevel": 2 },
					{ "groupName": "[ENV]_CONFIG_ADM", "label": "ADMIN",  "accessLevel": 3 }
				]
			}
		]
	};

	constructor() {
		super();
	}

	get permissions(): any[] {
		return this._groups.permissions;
	}
}

@Injectable()
export class TestPermissionsRepo extends IPermissionsRepo {

	private permissions: Permission[] = [];
	private _permissionChecker: PermissionChecker;

	constructor() {
		super();
		this.provisionPermissions();
	}

	getPermissions(): Promise<PermissionChecker> {
		return Promise.resolve(this._permissionChecker);
	}

	provisionPermissions(): void {
		const rawPermissions: any[] = [
			{
				"environment": "DEV",
				"permissions": [
					{
						"permission": "ADMIN",
						"accessLevels": [
							{ "groupName": "dev_SUPER_ADM", "label": "ADMIN", "accessLevel": 10000000 }
						]
					},
					{
						"permission": "OrganizationProvision",
						"accessLevels": [
							{ "groupName": "dev_ORG_RD",  "label": "READ",   "accessLevel": 1 },
							{ "groupName": "dev_ORG_UPD", "label": "UPDATE", "accessLevel": 2 },
							{ "groupName": "dev_ORG_ADM", "label": "ADMIN",  "accessLevel": 3 }
						]
					},
					{
						"permission": "UserManagement",
						"accessLevels": [
							{ "groupName": "dev_USR_MGT_RD",  "label": "READ",   "accessLevel": 1 },
							{ "groupName": "dev_USR_MGT_UPD", "label": "UPDATE", "accessLevel": 2 },
							{ "groupName": "dev_USR_MGT_ADM", "label": "ADMIN",  "accessLevel": 3 }
						]
					},
					{
						"permission": "IdeaManagement",
						"accessLevels": [
							{ "groupName": "dev_IDEA_RD",  "label": "READ",   "accessLevel": 1 },
							{ "groupName": "dev_IDEA_UPD", "label": "UPDATE", "accessLevel": 2 },
							{ "groupName": "dev_IDEA_ADM", "label": "ADMIN",  "accessLevel": 3 }
						]
					},
					{
						"permission": "PillarManagement",
						"accessLevels": [
							{ "groupName": "dev_PILLAR_RD",  "label": "READ",  "accessLevel": 1 },
							{ "groupName": "dev_PILLAR_ADM", "label": "ADMIN", "accessLevel": 3 }
						]
					},
					{
						"permission": "FloorManagement",
						"accessLevels": [
							{ "groupName": "dev_FLOOR_RD",  "label": "READ",  "accessLevel": 1 },
							{ "groupName": "dev_FLOOR_ADM", "label": "ADMIN", "accessLevel": 3 }
						]
					},
					{
						"permission": "ModerationManagement",
						"accessLevels": [
							{ "groupName": "dev_MOD_RD",  "label": "READ",  "accessLevel": 1 },
							{ "groupName": "dev_MOD_ADM", "label": "ADMIN", "accessLevel": 3 }
						]
					},
					{
						"permission": "ConfigManagement",
						"accessLevels": [
							{ "groupName": "dev_CONFIG_RD",  "label": "READ",   "accessLevel": 1 },
							{ "groupName": "dev_CONFIG_UPD", "label": "UPDATE", "accessLevel": 2 },
							{ "groupName": "dev_CONFIG_ADM", "label": "ADMIN",  "accessLevel": 3 }
						]
					}
				]
			}
		];

		rawPermissions.forEach(
			(rawPermission: any) => {
				this.permissions.push(new Permission(rawPermission, 'DEV'));
			}
		);
		this._permissionChecker = new PermissionChecker('dev', new TestGroupsConfig());
	}
}
